var translations = {
    'uk': {
        load_units_error: 'Помилка завантаження даних',
    },
    'ru': {
        load_units_error: 'Ошибка загрузки данных',
    },
    'en': {
        load_units_error: 'Error loading data',
    }
};
var UnitsFilter = {
    // Настройки
    settings: {
        catId: null,
        lang: $('html').attr('lang') || 'uk',
        currentFilters: {},
        currentSorting: 'default',
        currentPage: 1,
        isLoading: false,
        ajaxUrl: {
            loadFilters: '/service/load-filters',
            loadUnits: '/service/load-units'
        }
    },

    init: function (catId) {
        this.settings.catId = catId;
        this.initFromUrl();
        this.bindEvents();
        this.loadFilters();
    },

    bindEvents: function () {
        var self = this;

        $(document).on('change', '.js__filter-checkbox', function () {
            self.settings.currentPage = 1;
            self.handleFilterChange();
        });

        $(document).on('click', '.js__reset-filters', function (e) {
            e.preventDefault();
            self.resetFilters();
        });

        $(document).on('change', '.js__sorting-select', function () {
            self.settings.currentSorting = $(this).val();
            self.settings.currentPage = 1;
            self.updateUrl();
            self.loadUnits();
        });

        $(document).on('click', '.js__filter-group-title', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next('.filter-group-values').slideToggle(200);
        });

        $(document).on('click', '.js__show-more-values', function (e) {
            e.preventDefault();
            $(this).closest('.filter-group').find('.js__filter-value-item.hidden').removeClass('hidden');
            $(this).hide();
        });

        $(window).on('popstate', function (e) {
            self.initFromUrl();
            self.loadFilters();
            self.loadUnits();
        });
    },

    handleFilterChange: function () {
        this.collectFilters();
        this.updateUrl();
        this.loadUnits();
        this.loadFilters();
    },

    collectFilters: function () {
        var filters = { vals: [] };

        $('.js__filter-checkbox:checked').each(function () {
            var charId = $(this).data('char-id');
            var valId = $(this).data('val-id');
            filters.vals.push(charId + '_' + valId);
        });

        this.settings.currentFilters = filters;
    },

    filtersToString: function () {
        if (!this.settings.currentFilters.vals || this.settings.currentFilters.vals.length === 0) {
            return '';
        }

        var filterString = JSON.stringify(this.settings.currentFilters);
        filterString = filterString
            .replace(/\{/g, 'lu')
            .replace(/\}/g, 'ru')
            .replace(/"/g, 'kv')
            .replace(/:/g, 'dv')
            .replace(/,/g, 'zp')
            .replace(/\[/g, 'lk')
            .replace(/\]/g, 'rk');

        return filterString;
    },

    stringToFilters: function (filterString) {
        if (!filterString) {
            return {};
        }

        filterString = filterString
            .replace(/lu/g, '{')
            .replace(/ru/g, '}')
            .replace(/kv/g, '"')
            .replace(/dv/g, ':')
            .replace(/zp/g, ',')
            .replace(/lk/g, '[')
            .replace(/rk/g, ']');

        try {
            return JSON.parse(filterString);
        } catch (e) {
            return {};
        }
    },

    updateUrl: function () {
        var filterString = this.filtersToString();
        var params = new URLSearchParams();

        if (filterString) {
            params.set('filters', filterString);
        }

        if (this.settings.currentSorting !== 'default') {
            params.set('sorting', this.settings.currentSorting);
        }

        if (this.settings.currentPage > 1) {
            params.set('page', this.settings.currentPage);
        }

        var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.history.pushState({
            filters: this.settings.currentFilters,
            sorting: this.settings.currentSorting,
            page: this.settings.currentPage
        }, '', newUrl);
    },

    loadFilters: function () {
        var self = this;

        $.ajax({
            url: self.settings.ajaxUrl.loadFilters,
            type: 'POST',
            data: {
                cat_id: self.settings.catId,
                filters: self.filtersToString(),
                lang: self.settings.lang,
            },
            beforeSend: function () {
                $('.js__filters-container').addClass('loading');
            },
            success: function (response) {
                if (response.status === 'success') {
                    if (response.is_filters) {
                        $('.js__filters-container').show();
                        $('.js__filters-container').html(response.html)
                        self.updateFilterCounts();
                    } else {
                        $('.js__filters-container').hide();
                    }
                }
            },
            error: function (xhr, status, error) {
                console.error('Error loading filters:', error);
            },
            complete: function () {
                $('.js__filters-container').removeClass('loading');
            }
        });
    },

    loadUnits: function () {
        var self = this;

        if (self.settings.isLoading) return;

        $.ajax({
            url: self.settings.ajaxUrl.loadUnits,
            type: 'POST',
            data: {
                cat_id: self.settings.catId,
                filters: self.filtersToString(),
                sorting: self.settings.currentSorting,
                view: typeof view !== 'undefined' ? view : 'pages.blog.units_items',
                page: self.settings.currentPage,
                lang: self.settings.lang,
            },
            beforeSend: function () {
                self.settings.isLoading = true;
                $('.js__units-container').addClass('loading');

                if (!$('.js__loading-overlay').length) {
                    $('.js__units-container').append('<div class="js__loading-overlay"><div class="spinner"></div></div>');
                }
            },
            success: function (response) {
                if (response.status === 'success') {
                    $('.js__units-container').html(response.data.units);
                    self.scrollToUnits();
                }
            },
            error: function (xhr, status, error) {
                console.error('Error loading units:', error);
                var currentLang = window.lang || 'uk';
                var errorText = translations[currentLang]['load_units_error'] || 'Error loading data';
                $('.js__units-container').html('<p class="errors">' + errorText + '</p>');
            },
            complete: function () {
                self.settings.isLoading = false;
                $('.js__units-container').removeClass('loading');
                $('.js__loading-overlay').remove();
            }
        });
    },

    scrollToUnits: function () {
        var container = $('.js__units-container');
        if (container.length) {
            $('html, body').animate({
                scrollTop: container.offset().top - 100
            }, 300);
        }
    },

    updateFilterCounts: function () {
        $('.js__filter-value-item').each(function () {
            var count = parseInt($(this).find('.filter-count').text());
            if (count === 0) {
                $(this).addClass('disabled');
                $(this).find('.js__filter-checkbox').prop('disabled', true);
            } else {
                $(this).removeClass('disabled');
                $(this).find('.js__filter-checkbox').prop('disabled', false);
            }
        });
    },

    resetFilters: function () {
        $('.js__filter-checkbox').prop('checked', false);
        this.settings.currentFilters = {};
        this.settings.currentSorting = 'default';
        this.settings.currentPage = 1;
        $('.js__sorting-select').val('default');
        this.updateUrl();
        this.loadUnits();
        this.loadFilters();
    },

    initFromUrl: function () {
        var params = new URLSearchParams(window.location.search);
        var filterString = params.get('filters');
        var sorting = params.get('sorting');
        var page = params.get('page');

        if (filterString) {
            this.settings.currentFilters = this.stringToFilters(filterString);
        } else {
            this.settings.currentFilters = {};
        }

        if (sorting) {
            this.settings.currentSorting = sorting;
            $('.js__sorting-select').val(sorting);
        } else {
            this.settings.currentSorting = 'default';
            $('.js__sorting-select').val('default');
        }

        if (page) {
            this.settings.currentPage = parseInt(page);
        } else {
            this.settings.currentPage = 1;
        }
    },

    getCurrentParams: function () {
        return {
            filters: this.settings.currentFilters,
            sorting: this.settings.currentSorting,
            page: this.settings.currentPage
        };
    }
};

window.UnitsFilter = UnitsFilter;

$(document).ready(function () {
    var catId = $('.js__units-catalog').data('cat-id');
    if (catId) {
        UnitsFilter.init(catId);
    }
});
